import { render } from "./generalformcta.vue?vue&type=template&id=c60f8260&scoped=true"
import script from "./generalformcta.vue?vue&type=script&lang=js"
export * from "./generalformcta.vue?vue&type=script&lang=js"

import "./generalformcta.vue?vue&type=style&index=0&id=c60f8260&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c60f8260"

export default script